import { HTMLAttributes } from 'react'

export default (props: HTMLAttributes<SVGElement>) => (
  <svg
    {...props}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{backgroundColor: 'var(--button-bg-color)'}}
  >
    {/* <g clipPath='url(#clip0_101_2)'> */}
    <g transform='translate(4.91, 4.50)'>
      <path
        d='m4.91,14.1v-5.35H0v-3.4h4.91V0h3.72v5.35h4.91v3.4h-4.91v5.35h-3.72Z'
        fill='var(--button-label-color)'
      />
    </g>
  </svg>
)
